import { SELECT_CURSOR, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IHoverElement, useLandingStore } from "src/modules/pe-landing-module/data/store"

export default function setHoverData( 
    element: Element | undefined = undefined, 
    selectType: SELECT_TYPE = SELECT_TYPE.NONE,
    cursor: SELECT_CURSOR = SELECT_CURSOR.SECTION
): IHoverElement | undefined {
    if(!element ) {
        useLandingStore.setState({ hoverElement: null })
        return undefined
    }
    const sectionElem: HTMLDivElement | null  = element.closest(".landing-section-container.landing-gap[id]")
    if(!sectionElem) {
        useLandingStore.setState({ hoverElement: null })
        return undefined
    }
    const sectionId                     = sectionElem.getAttribute("id") || "" 
    const id                            = element.getAttribute("data-content-id") || ""    
    const sectionBound                  = sectionElem.getBoundingClientRect()
    let elemBound                       = element.getBoundingClientRect()
    
    const bound  = {
        top: elemBound.top - sectionBound.top + sectionElem.offsetTop,
        left: elemBound.left - sectionBound.left,
        width: elemBound.width,
        height: elemBound.height,
    }
    // console.log( bound, sectionElem.offsetTop )
    
    const hoverElement: IHoverElement   =  {
            sectionId,
            id, 
            selectType,
            bound, 
            cursor
        }
    useLandingStore.setState({
        hoverElement
    })
    return hoverElement
}